module.exports = __webpack_public_path__ + "img/user1.a40a401d.png";